import React from 'react';
import EImg from './EImg';

const EWrite = ({ width = 24, height = 24 }) => (
	<EImg
		width={width}
		height={height}
		title="Writing"
		aria-label="Emoji: Writing hand"
		alt="✍️"
		src="https://abs.twimg.com/emoji/v2/72x72/270d.png"
	/>
);

export default EWrite;
